import { Panel } from '@piggybank/core';

Panel.isWrapper = true;

export { Panel };
